import React, { useState,useEffect  } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { getParametersFromLocalStorage } from "../../../helpers/commonHelper";
import { initReactI18next, useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getPassportScanData } from "../../../store/Checkin/Scan/scanPassportSlice";
import { getPropertyInfo } from "../../../store/Checkin/Scan/propertySlice";
import { postAuditLog, postStageDetails } from "../../../store/stageSlice";

const ConfirmLocalResidentModal = ({
showLocalResidentModal,
confirmLocalResident
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const userData = useSelector(getPassportScanData);
  const propertyData = useSelector(getPropertyInfo);
  const token = getParametersFromLocalStorage("token");
  const addStageDeatilsFaceForJapanResident = (IsSuccess, SuccessMessage, FailureReason) => {
    const data = {
      PMSConfirmationNo: userData?.pmsConfirmationNo,
      IsSuccess: IsSuccess,
      StepCode: "SKI04",
      SubStep: "FacialVerification",
      AppType: "kiosk",
      SuccessMessage: SuccessMessage ?? "",
      FailureReason: FailureReason ?? "",
      PropertyCode: propertyData?.data?.propertyCode,
    };

    dispatch(postStageDetails({ data, token }));
  };


  const addStageDeatilsDocScanForJapanResident = (IsSuccess, SuccessMessage, FailureReason) => {
      const confirmationNo = localStorage.getItem("confirmationNo");
      const propertyCode = localStorage.getItem("propertyCode");
      const data = {
        PMSConfirmationNo: confirmationNo,
        IsSuccess: IsSuccess,
        StepCode: "SKI03",
        SubStep: "DocumentUpload",
        AppType: "kiosk",
        SuccessMessage: SuccessMessage ?? "",
        FailureReason: FailureReason ?? "",
        PropertyCode: propertyCode,
      };
  
      if (confirmationNo === null || confirmationNo === undefined) return;
      dispatch(postStageDetails({ data, token }));
    };

  return (
    <div>
      <Modal open={showLocalResidentModal} style={{ zIndex: "1" }}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "800px",
            backgroundColor: "#f5f5f5",
            border: "2px #000",
            boxShadow: "0 0 24px rgba(0, 0, 0, 0.5)",
            padding: "70px",
            borderRadius: "20px",
          }}
        >
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2, textAlign: "center", fontSize: "1.8rem" }}
          >
            <p>{t("Are you a resident of Japan")+"?"}</p>
          </Typography>
          <div style={{ textAlign: "center" }}>

            <button id="btn-localresident-yes"
            style={{ marginTop: "20px", padding: "15px", marginLeft: "15px" }}
            className="btn button-blue scan-btn"
            onClick={() => {
                
                confirmLocalResident(true);
                 addStageDeatilsFaceForJapanResident(
                true,
                "Success",
                "");

                 addStageDeatilsDocScanForJapanResident(
                true,
                "Success",
                "");
            }}
            >
            {t("Yes")}
            </button>

            <button id="btn-localresident-no"
            style={{ marginTop: "20px", padding: "15px", marginLeft: "15px" }}
            className="btn button-blue scan-btn"
            onClick={() => {
              confirmLocalResident(false);
            }}
            >
            {t("No")}
            </button>
</div>
      
        </Box>
      </Modal>
    </div>
  );
};

export default ConfirmLocalResidentModal;
